'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var errCode = require('err-code');

var log = require('debug')('ipfs:mfs:mkdir');

var exporter = require('ipfs-unixfs-exporter');

var createNode = require('./utils/create-node');

var toPathComponents = require('./utils/to-path-components');

var updateMfsRoot = require('./utils/update-mfs-root');

var updateTree = require('./utils/update-tree');

var addLink = require('./utils/add-link');

var withMfsRoot = require('./utils/with-mfs-root');

var applyDefaultOptions = require('./utils/apply-default-options');

var defaultOptions = {
  parents: false,
  hashAlg: 'sha2-256',
  cidVersion: 0,
  shardSplitThreshold: 1000,
  flush: true,
  mode: null,
  mtime: null
};

module.exports = function (context) {
  return /*#__PURE__*/function () {
    var _mfsMkdir = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, options) {
      var pathComponents, root, parent, trail, emptyDir, i, subPathComponents, subPath, newRootCid;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = applyDefaultOptions(options, defaultOptions);

              if (path) {
                _context.next = 3;
                break;
              }

              throw new Error('no path given to Mkdir');

            case 3:
              path = path.trim();

              if (!(path === '/')) {
                _context.next = 8;
                break;
              }

              if (!options.parents) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              throw errCode(new Error('cannot create directory \'/\': Already exists'), 'ERR_INVALID_PATH');

            case 8:
              if (!(path.substring(0, 1) !== '/')) {
                _context.next = 10;
                break;
              }

              throw errCode(new Error('paths must start with a leading slash'), 'ERR_INVALID_PATH');

            case 10:
              log("Creating ".concat(path));
              pathComponents = toPathComponents(path);

              if (!(pathComponents[0] === 'ipfs')) {
                _context.next = 14;
                break;
              }

              throw errCode(new Error("path cannot have the prefix 'ipfs'"), 'ERR_INVALID_PATH');

            case 14:
              _context.next = 16;
              return withMfsRoot(context);

            case 16:
              root = _context.sent;
              trail = [];
              _context.next = 20;
              return createNode(context, 'directory', options);

            case 20:
              emptyDir = _context.sent;
              i = 0;

            case 22:
              if (!(i <= pathComponents.length)) {
                _context.next = 51;
                break;
              }

              subPathComponents = pathComponents.slice(0, i);
              subPath = "/ipfs/".concat(root, "/").concat(subPathComponents.join('/'));
              _context.prev = 25;
              _context.next = 28;
              return exporter(subPath, context.ipld);

            case 28:
              parent = _context.sent;
              log("".concat(subPath, " existed"));
              log("".concat(subPath, " had children ").concat(parent.node.Links.map(function (link) {
                return link.Name;
              })));

              if (!(i === pathComponents.length)) {
                _context.next = 35;
                break;
              }

              if (!options.parents) {
                _context.next = 34;
                break;
              }

              return _context.abrupt("return");

            case 34:
              throw errCode(new Error('file already exists'), 'ERR_ALREADY_EXISTS');

            case 35:
              trail.push({
                name: parent.name,
                cid: parent.cid
              });
              _context.next = 48;
              break;

            case 38:
              _context.prev = 38;
              _context.t0 = _context["catch"](25);

              if (!(_context.t0.code === 'ERR_NOT_FOUND')) {
                _context.next = 47;
                break;
              }

              if (!(i < pathComponents.length && !options.parents)) {
                _context.next = 43;
                break;
              }

              throw errCode(new Error("Intermediate directory path ".concat(subPath, " does not exist, use the -p flag to create it")), 'ERR_NOT_FOUND');

            case 43:
              _context.next = 45;
              return addEmptyDir(context, subPathComponents[subPathComponents.length - 1], emptyDir, trail[trail.length - 1], trail, options);

            case 45:
              _context.next = 48;
              break;

            case 47:
              throw _context.t0;

            case 48:
              i++;
              _context.next = 22;
              break;

            case 51:
              _context.next = 53;
              return updateTree(context, trail, options);

            case 53:
              newRootCid = _context.sent;
              _context.next = 56;
              return updateMfsRoot(context, newRootCid);

            case 56:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[25, 38]]);
    }));

    function mfsMkdir(_x, _x2) {
      return _mfsMkdir.apply(this, arguments);
    }

    return mfsMkdir;
  }();
};

var addEmptyDir = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context, childName, emptyDir, parent, trail, options) {
    var result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            log("Adding empty dir called ".concat(childName, " to ").concat(parent.cid));
            _context2.next = 3;
            return addLink(context, {
              parent: parent.node,
              parentCid: parent.cid,
              size: emptyDir.node.size,
              cid: emptyDir.cid,
              name: childName,
              hashAlg: options.hashAlg,
              cidVersion: options.cidVersion,
              flush: options.flush
            });

          case 3:
            result = _context2.sent;
            trail[trail.length - 1].cid = result.cid;
            trail.push({
              name: childName,
              cid: emptyDir.cid
            });

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function addEmptyDir(_x3, _x4, _x5, _x6, _x7, _x8) {
    return _ref.apply(this, arguments);
  };
}();